/**
 * Souřadnicový referenční systém (Coordinate Reference System).
 */
enum Crs {
    /**
     * World Geodetic System 1984.
     *
     * Používáno pro GPS.
     */
    WGS_84 = 'EPSG:4326',

    /**
     * S-JTSK / Krovak East North.
     *
     * Souřadnicový systém Jednotné trigonometrické sítě katastrální.
     * Použito Křovákovo zobrazení. Matematická orientace souřadnicových os
     * (osa x směřuje na východ, osa Y směřuje na sever, na území ČR jsou obě
     * souřadnice záporné). Definováno od nultého poledníku Greenwiche.
     */
    S_JTSK = 'EPSG:5514',

    /**
     * S-JTSK (Ferro) / Krovak East North.
     *
     * Souřadnicový systém Jednotné trigonometrické sítě katastrální.
     * Použito Křovákovo zobrazení. Matematická orientace souřadnicových os
     * (osa X směřuje na východ, osa Y směřuje na sever, na území ČR jsou obě
     * souřadnice záporné). Definováno od nultého poledníku Ferro.
     */
    S_JTSK_FERRO = 'EPSG:5221',
}

export default Crs;